import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { BettingMarketSuspensionsEditorResponse } from "@/types/ApiResponses/BettingMarket";

export interface GetBettingMarketsSuspensionsParams {
  lang?: string;
  // Sport scope by category ("football" | "basketball"). Omitted → all markets.
  sportCategory?: string;
  targetUsername?: string;
}

export const getBettingMarketsSuspensions = async (
  props: QueryProps<GetBettingMarketsSuspensionsParams>
): Promise<BettingMarketSuspensionsEditorResponse> => {
  const res = await api.client.get(`/betting-markets-new/suspensions`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
